import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { Screen } from './Screen';

const meta: Meta<typeof Screen> = {
  title: 'parts/ending/Screen',
  component: Screen,
  args: {
    onNextStep: action('click'),
    onSkipDialogue: action('click'),
    children: <p>test</p>,
  },
};

export default meta;

type Story = StoryObj<typeof Screen>;

export const Basic: Story = {
  render: args => <Screen {...args} />,
};
